import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { TrustStrip } from '../components/sections/TrustStrip';
import { PainsSection } from '../components/sections/PainsSection';
import { IntroSection } from '../components/sections/IntroSection';
import { TransformationSection } from '../components/sections/TransformationSection';
import { IncludesSection } from '../components/sections/IncludesSection';
import { PostsGallerySection } from '../components/sections/PostsGallerySection';
import { WhatsAppSection } from '../components/sections/WhatsAppSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { FitSection } from '../components/sections/FitSection';
import { OfferSection } from '../components/sections/OfferSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { RefundSection } from '../components/sections/RefundSection';
import { SupportSection } from '../components/sections/SupportSection';
import { FaqSection } from '../components/sections/FaqSection';
import { FinalCtaSection } from '../components/sections/FinalCtaSection';
import { SiteFooter } from '../components/SiteFooter';
import { StickyBuyBar } from '../components/StickyBuyBar';
import { useMetaPixel } from '../hooks/useMetaPixel';
type LandingProps = {
  showTestimonials: boolean;
  showStickyBar: boolean;
};
export function Landing({
  showTestimonials,
  showStickyBar
}: LandingProps) {
  useMetaPixel();
  return <div className="w-full bg-white font-sans text-[16px] leading-relaxed text-ink md:text-[17px]" data-id="element-294" data-mp="h1aks60u6zc9">
      <HeroSection data-id="element-295" data-mp="c5va1my4ljk2" />
      <main data-id="element-296" data-mp="79d4wlyvvj77">
        <TrustStrip data-id="element-297" data-mp="79wpybjtynpg" />
        <PainsSection data-id="element-298" data-mp="78bwyqd5zctp" />
        <IntroSection data-id="element-299" data-mp="78v4re93oku0" />
        <TransformationSection data-id="element-300" data-mp="14oiqgp26gaet" />
        <IncludesSection data-id="element-301" data-mp="14or5onlrvrt6" />
        <PostsGallerySection data-id="element-302" data-mp="14q256b86qdeh" />
        <WhatsAppSection data-id="element-303" data-mp="14qbudwleogj4" />
        <HowItWorksSection data-id="element-304" data-mp="zx90fncpv52e" />
        <FitSection data-id="element-305" data-mp="zx0pw242gbud" />
        <OfferSection data-id="element-306" data-mp="zwhdf0x6qfnq" />
        <GuaranteeSection data-id="element-307" data-mp="1iu13ltq0jthy" />
        {showTestimonials && <TestimonialsSection data-id="element-308" data-mp="1ivc6zsfjqz8j" />}
        <RefundSection data-id="element-309" data-mp="1iw43d5gyx0zv" />
        <SupportSection data-id="element-310" data-mp="1nsuldycc26nx" />
        <FaqSection data-id="element-311" data-mp="1ns2nggv9jwuh" />
        <FinalCtaSection data-id="element-312" data-mp="1nsm6y20katam" />
      </main>
      <SiteFooter data-id="element-313" data-mp="1a1ph2iy0sq79" />
      {showStickyBar && <StickyBuyBar data-id="element-314" data-mp="1a0o4ub59pxny" />}
    </div>;
}